import React from "react";
import { Link } from "react-router-dom";
import { Button, TextInput } from "../../../../../components";
import ParentStudentSwitch from "./ParentStudentSwitch";

const DetailsRegistrationForm = ({
  emailExistsMode,
  setEmailExistsMode,
  isFromLoginRedirect,
  registerAs,
  setRegisterAs,
  name,
  setName,
  email,
  setEmail,
  password,
  setPassword,
  handleDetailsSubmit,
  handleDetailsGoBack,
  handleSignInExisting,
  loading,
  error,
  setError,
  resetFieldError,
}) => {
  if (emailExistsMode) {
    return (
      <form onSubmit={handleDetailsSubmit} className="w-full h-full flex flex-col justify-start" noValidate>
        {/* Back Button */}
        <button
          type="button"
          onClick={() => {
            setEmailExistsMode(false);
            setPassword("");
            if (setError) setError(null);
          }}
          className="inline-flex items-center gap-1.5 text-xs sm:text-sm font-bold text-gray-800 hover:text-black mb-2 transition-colors w-fit focus:outline-none cursor-pointer"
        >
          <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
          </svg>
          <span>Back</span>
        </button>

        {/* Heading & Subheading */}
        <h3 className="text-xl sm:text-2xl font-extrabold text-[#111827] tracking-tight leading-tight mb-0.5">
          Link Existing Account
        </h3>
        <p className="text-xs text-gray-500 font-medium mb-4 leading-relaxed">
          An account already exists for <span className="font-bold text-gray-800">{email}</span>. Enter your password to link your WhatsApp number.
        </p>

        {/* Locked Email Input */}
        <div className="form-group flex flex-col mb-3">
          <label htmlFor="email" className="text-xs sm:text-sm font-bold text-gray-700 mb-1">
            Email Address
          </label>
          <TextInput
            type="email"
            placeholderText="alex@example.com"
            inputName="email"
            inputValue={email}
            isRequired={true}
            isDisabled={true}
            inputClassName="!h-[44px] !rounded-xl !bg-gray-100 !border-gray-200 !text-gray-500 !text-sm cursor-not-allowed"
            leftIcon={
              <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
              </svg>
            }
          />
        </div>

        {/* Password Input */}
        <div className="form-group flex flex-col mb-2">
          <div className="flex items-center justify-between mb-1">
            <label htmlFor="password" className="text-xs sm:text-sm font-bold text-gray-700">
              Account Password <span className="text-[#E5383B]">*</span>
            </label>
            <Link
              to="/login/forgotPassword"
              className="text-xs font-bold text-[#009DFF] hover:underline"
            >
              Forgot Password?
            </Link>
          </div>
          <TextInput
            type="password"
            placeholderText="••••••••"
            inputName="password"
            inputValue={password}
            isRequired={true}
            inputClassName="!h-[44px] !rounded-xl !bg-white !border-gray-200 focus:!border-[#6366F1] !text-sm"
            leftIcon={
              <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
              </svg>
            }
            handleChange={(e) => {
              setPassword(e.target.value);
              if (resetFieldError) resetFieldError("password");
            }}
          />
          {error?.password && <div className="text-xs text-[#f00] mt-1 pl-1">{error.password}</div>}
        </div>

        {error?.other && (
          <div className="text-[#E5383B] text-xs font-semibold mb-2.5">{error.other}</div>
        )}

        {/* Submit Button */}
        <div className="w-full mt-2">
          <Button
            version="secondary"
            text="Link Account & Continue"
            children={
              <svg className="w-4 h-4 ml-1 inline-block" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
              </svg>
            }
            type="submit"
            loading={loading}
            width="100%"
            className="w-full justify-center font-extrabold"
          />
        </div>

        {/* Use Different Email Link */}
        <div className="text-center mt-4">
          <button
            type="button"
            onClick={() => {
              setEmailExistsMode(false);
              setPassword("");
              if (setError) setError(null);
            }}
            className="text-xs font-bold text-[#009DFF] hover:underline focus:outline-none cursor-pointer"
          >
            ← Use a different email address
          </button>
        </div>
      </form>
    );
  }

  return (
    <form onSubmit={handleDetailsSubmit} className="w-full h-full flex flex-col justify-start" noValidate>
      {/* Back Button */}
      <button
        type="button"
        onClick={handleDetailsGoBack}
        disabled={loading}
        className="inline-flex items-center gap-1.5 text-xs sm:text-sm font-bold text-gray-800 hover:text-black mb-2 transition-colors w-fit focus:outline-none cursor-pointer"
      >
        <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
        </svg>
        <span>Back</span>
      </button>

      {/* Heading & Subheading */}
      <h3 className="text-xl sm:text-2xl font-extrabold text-[#111827] tracking-tight leading-tight mb-0.5">
        Enter Your Details
      </h3>
      <p className="text-xs text-gray-500 font-medium mb-4">
        Sign up to continue your learning journey
      </p>

      {/* TODO: Re-activate role switcher in future releases
      {isFromLoginRedirect && (
        <ParentStudentSwitch
          registerAs={registerAs}
          setRegisterAs={setRegisterAs}
          labels={{ parent: "I'm Parent", student: "I'm Student" }}
        />
      )}
      */}

      {/* Full Name Input */}
      <div className="form-group flex flex-col mb-3">
        <label htmlFor="name" className="text-xs sm:text-sm font-bold text-gray-700 mb-1">
          Full Name <span className="text-[#E5383B]">*</span>
        </label>
        <TextInput
          type="text"
          placeholderText="Alex Johnson"
          inputName="name"
          inputValue={name}
          isRequired={true}
          inputClassName="!h-[44px] !rounded-xl !bg-white !border-gray-200 focus:!border-[#6366F1] !text-sm"
          leftIcon={
            <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
            </svg>
          }
          handleChange={(e) => {
            setName(e.target.value);
            if (resetFieldError) resetFieldError("name");
          }}
        />
        {error?.name && <div className="text-xs text-[#f00] mt-1 pl-1">{error.name}</div>}
      </div>

      {/* Email Address Input */}
      <div className="form-group flex flex-col mb-3">
        <label htmlFor="email" className="text-xs sm:text-sm font-bold text-gray-700 mb-1">
          Email Address <span className="text-[#E5383B]">*</span>
        </label>
        <TextInput
          type="email"
          placeholderText="alex@example.com"
          inputName="email"
          inputValue={email}
          isRequired={true}
          inputClassName="!h-[44px] !rounded-xl !bg-white !border-gray-200 focus:!border-[#6366F1] !text-sm"
          leftIcon={
            <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
            </svg>
          }
          handleChange={(e) => {
            setEmail(e.target.value);
            if (resetFieldError) resetFieldError("email");
          }}
        />
        {error?.emailCollision ? (
          <div className="bg-amber-50 border border-amber-200 rounded-2xl p-4 mt-2 mb-2 text-left shadow-sm">
            <div className="flex items-start gap-2.5">
              <div className="w-6 h-6 rounded-full bg-amber-100 flex items-center justify-center shrink-0 text-amber-600 mt-0.5">
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                </svg>
              </div>
              <div className="flex-1">
                <h4 className="text-xs font-bold text-amber-900 leading-tight">
                  Email Already In Use
                </h4>
                <p className="text-xs text-amber-800/90 mt-1 leading-relaxed">
                  {error.emailCollision.maskedPhone ? (
                    <>
                      The email <strong className="font-semibold text-amber-950">{error.emailCollision.email}</strong> is already registered and linked with phone number <strong className="font-semibold text-amber-950">{error.emailCollision.maskedPhone}</strong>.
                    </>
                  ) : error.emailCollision.provider === "google.com" ? (
                    <>
                      The email <strong className="font-semibold text-amber-950">{error.emailCollision.email}</strong> is already registered via Google Sign-In.
                    </>
                  ) : (
                    <>
                      The email <strong className="font-semibold text-amber-950">{error.emailCollision.email}</strong> is already registered and linked to an existing account.
                    </>
                  )}
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-2 mt-3 pt-2.5 border-t border-amber-200/70">
              <button
                type="button"
                onClick={handleSignInExisting}
                className="w-full sm:w-auto text-center px-3.5 py-1.5 rounded-xl bg-amber-600 hover:bg-amber-700 text-white text-xs font-bold transition-colors shadow-sm cursor-pointer"
              >
                Sign In to Existing Account
              </button>
              <button
                type="button"
                onClick={() => {
                  setEmail("");
                  if (resetFieldError) resetFieldError("email");
                }}
                className="w-full sm:w-auto text-center px-3 py-1.5 rounded-xl bg-white hover:bg-amber-100/60 border border-amber-300 text-amber-900 text-xs font-bold transition-colors cursor-pointer"
              >
                Use a Different Email
              </button>
            </div>
          </div>
        ) : (
          error?.email && <div className="text-xs text-[#f00] mt-1 pl-1">{error.email}</div>
        )}
      </div>

      {error?.other && (
        <div className="text-[#E5383B] text-xs font-semibold mb-2.5">{error.other}</div>
      )}

      {/* Submit Button */}
      <div className="w-full mt-2">
        <Button
          version="secondary"
          text="Complete Sign Up"
          children={
            <svg className="w-4 h-4 ml-1 inline-block" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
            </svg>
          }
          type="submit"
          loading={loading}
          width="100%"
          className="w-full justify-center font-extrabold"
        />
      </div>
    </form>
  );
};

export default DetailsRegistrationForm;
